<div class="empty-state" [class.empty-state--compact]="compact" role="status">
  <div class="empty-state__badge">
    <fa-icon [icon]="icon"></fa-icon>
  </div>
  <p class="empty-state__headline">{{ headline }}</p>
  <p class="empty-state__hint" *ngIf="hint">{{ hint }}</p>
</div>
